module.exports = __webpack_public_path__ + "img/resume-parser.f71431d9.svg";